import app from 'app';
import ready from 'utils/ready';
import faq from './pages/faq';
import faqMobile from './pages/faq-mobile';
import faqAnswerDrawer from './pages/faq-answer-drawer';

app.add({
  faq,
  faqMobile,
  faqAnswerDrawer,
});

ready(app.mount);
